/**
* this is the component for the transaction list
*
* Created by Tom on 15/06/18
*/
import moment from 'moment'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import ReactTable from "react-table"
import "react-table/react-table.css"


import { intlNumberFormatter } from '../../utility/utilities'

// action import
import { ActionCreator } from '../../actions/'

// component import
import CustomDatePicker from '../../components/CustomDatePicker/'

// icon imports
import CalendarIcon from '../../assets/svg/calendar.svg'

// style import
import './style.scss'

// import the table column definitions
import tableColumns from './tableColumns'


class Transaction extends Component {

    _onStartDateChange(date) {
        const { setTransactionStartDate,  getTransactionData, tEndDate,  setTransactionEndDate } = this.props
        // set the start date in store
        setTransactionStartDate(date)
        const isAfter = moment(date).isAfter(tEndDate);
        if(isAfter === true) 
            setTransactionEndDate(date)

        getTransactionData()
    }

    _onEndDateChange(date) {
        const { setTransactionEndDate, getTransactionData } = this.props
        // set the end date in store
        setTransactionEndDate(date)
        getTransactionData()
    }

    _onClearClick(e) {
        const { clearDateRange, getTransactionData } = this.props
        // do not refresh page
        e.preventDefault()
        e.stopPropagation()
        // reset the date range
        clearDateRange()
        getTransactionData()
    }

    render() {

        const { tEndDate, tStartDate,  tData, tClosingBalance } = this.props

        // populate closing balance string i.e. $34,456
        const closingBalance = intlNumberFormatter('en-AU', 'currency', 'AUD', tClosingBalance)

        return (
            <div
                className="transaction"
                ref={componentRef => this.transactionDIV = componentRef}>

                {/* header container*/}
                <div className="transaction__header">

                    <div className="transaction__header__title">
                        <p>TRANSACTION AMOUNT</p>
                    </div>

                    <div className="transaction__header__balance">
                        <p className="transaction__header__balance__amount">
                            BALANCE:&nbsp;&nbsp;&nbsp;{closingBalance}
                        </p>
                        <p className="transaction__header__balance__descr">
                            Closing balance from yesterday
                        </p>
                    </div>

                </div>

                {/* date range container*/}
                <div className="transaction__date-range">

                    {/* date range description */}
                    <div className="transaction__date-range__title">
                        <p>Date range</p>
                    </div>

                    {/* container that contains the pcikers and clear link */}
                    <div className="transaction__date-range__picker-container">

                        <div className="transaction__date-range__picker-start">
                            {/* datepicker component for start date */}
                            <CustomDatePicker
                                icon={CalendarIcon}
                                date={tStartDate}
                                dateFormat="DD MMM YY"
                                onDateChange={::this._onStartDateChange} />
                        </div>


                        {/* datepicker component for end date */}
                        <CustomDatePicker
                            icon={CalendarIcon}
                            date={tEndDate}
                            dateFormat="DD MMM YY"
                            minDate={tStartDate}
                            onDateChange={::this._onEndDateChange} />

                        {/* date range clear link */}
                        <a
                            href=""
                            className="transaction__date-range__clear"
                            onClick={::this._onClearClick}>
                            Clear
                        </a>

                    </div>

                </div>

                {/* table wrapper for horizontal scolling */}
                <div
                    className="transaction__table-wrapper"
                    >

                    {/* https://react-table.js.org/#/story/simple-table */}
                    <ReactTable
                        className="tTable -highlight"
                        noDataText="No transactions available"
                        showPagination={false}
                        resizable={false}
                        pageSize={tData.length || 0}
                        data={tData}
                        columns={tableColumns}
                        minRows= {0}
                    />

                </div>

            </div>
        )
    }
}

// define the prop types
Transaction.propTypes = {
    setTransactionStartDate: PropTypes.func.isRequired,
    setTransactionEndDate: PropTypes.func.isRequired,
    tClosingBalance: PropTypes.number, // although it's a FLOAT
    clearDateRange: PropTypes.func.isRequired,
    tStartDate: PropTypes.object,
    tEndDate: PropTypes.object,
    tData: PropTypes.array
}

// pull props to this container
const mapStateToProps = (state) => {
    return {
        tClosingBalance: state.transactionState.closingBalance,
        tStartDate: state.transactionState.startDate,
        tEndDate: state.transactionState.endDate,
        tData: state.transactionState.data
    }
}

// pull all required action creators into this container
const mapDispatchToProps = (dispatch) => {
    const action = bindActionCreators(ActionCreator, dispatch)
    return {
        setTransactionStartDate: action.setTransactionStartDate,
        setTransactionEndDate: action.setTransactionEndDate,
        clearDateRange: action.clearDateRange,
        getTransactionData: action.getTransactionData
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Transaction)



// WEBPACK FOOTER //
// ./src/components/Transaction/index.js